module.exports = __webpack_public_path__ + "static/media/registerBg2.5d4fe5af.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/registerBg2.jpeg
// module id = 1849
// module chunks = 0 1